import React, { useEffect, useMemo, useState } from 'react'
import { useQuery } from 'react-query'
import Loading from 'src/components/Loading'
import { useOffer } from 'src/hooks/offer'
import { getSection } from 'src/hooks/useContentful/getSection'
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent'
import CardPlan from './CardPlan'
import contentfulClient from '../../../../services/contentful'
import {
	Button,
	Container,
	ErrorText,
	LoadingCupom,
	Modal,
	ModalDescription,
	ModalInput,
	ModalTitle,
	Plans,
	Sorriso,
	Title
} from './styles'
import Footer from './Footer'
import { useMiddlewareOffer } from 'src/hooks/useMiddlewareOffer'

function Planos() {
	const [modalOpen, setModalOpen] = useState(true)
	const [promoCode, setPromoCode] = useState('')
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)
	const { setCurrentOffer } = useOffer()
	const { data, isLoading, isError } = useMiddlewareOffer()
	const content = useFetchContent()

	const promotionalCodes = useMemo(
		() => content.data.fields.promotionalCodes.split('@')[0],
		[content.data.fields.promotionalCodes]
	)
	const codeModal = useMemo(() => content.data.fields.cuponsComRegulamentoProprio, [content.data.fields]);

	const hasCoupon = useMemo(() => content.data.fields.hasCoupon, [
		content.data.fields.hasCoupon
	])

	const section = getSection({
		sectionName: 'landingDefaultPromo',
		data: content.data
	})
	const sectionCupom = getSection({
		sectionName: 'landingCouponCard',
		data: content.data
	});

	const typePlans = ['pedagiosEstacionamentos', 'estacionamentos', 'pedagios']

	const plans = useQuery(
		'getCardPlan',
		() =>
			Promise.all(
				typePlans
					.filter(field => Object.keys(section).includes(field))
					.map(
						async field =>
							await contentfulClient.getEntry(section[field].sys.id)
					)
			),
		{
			enabled: content.data && !content.isLoading,
			retry: false
		}
	)

	const handleLoadOffer = async () => {
		const acceptedCodes = codeModal.map(code => code.fields.cupom)

		if (!acceptedCodes.includes(promoCode)) {
			setError('O código informado é inválido, tente outro código.')
			return
		}

		setCurrentOffer(promotionalCodes)
	}

	useEffect(() => {
		setLoading(plans.isLoading || content.isLoading)
	}, [plans.isLoading, content.isLoading])

	useEffect(() => {
		setModalOpen(hasCoupon && (!data || isLoading))
	}, [hasCoupon, data, isLoading])

	useEffect(() => {
		if (isError)
			setError(
				'Estamos com problemas para carregar os planos, tente novamente mais tarde.'
			)
	}, [isError])

	if (loading || !plans.data) return <Loading />

	return (
		<Container id="plans">
			<Title>{section.title}</Title>
			<Sorriso />
			<Plans size={plans.data.length}>
				{plans.data?.map((plan, index) => (
					<CardPlan item={plan} data={data} key={index} blur={modalOpen} />
				))}
			</Plans>


			<Footer
				buttonColor={section.buttonColor}
				terms={section.regulamento}
				textColor={'#FFFFFF'}
				modalOpen={modalOpen}
				cupons={[
					plans.data[0].fields.firstButtonCoupon,
					plans.data[0].fields.secondButtonCoupon
				]}
				disabled={modalOpen}
			/>

			{modalOpen && (
				<Modal open={modalOpen} backgroundColor={sectionCupom.couponCardBgColor}>
					{/* Oferta exclusiva para clientes DUX */}
					<ModalTitle color={sectionCupom.couponCardTitleColor}>{sectionCupom.couponCardTitle}</ModalTitle>
					<ModalDescription>
						{sectionCupom.couponCardAuxText}
					</ModalDescription>
					<ModalInput
						placeholder="Código promocional"
						value={promoCode}
						onChange={e => {
							if (error) setError(null)
							setPromoCode(e.target.value.toUpperCase())
						}}
					/>
					{error && <ErrorText>{error}</ErrorText>}
					<Button
						className="botaoConfirmar"
						disabled={loading || plans.isLoading || !promoCode || isLoading}
						color={sectionCupom.couponCardPrimaryButtonTextColor}
						backgroundColor={sectionCupom.couponCardPrimaryButtonColor}
						onClick={handleLoadOffer}
					>
						{isLoading ? (
							<LoadingCupom
								src="/clientedux/assets/loading.svg"
								alt="Carregando"
							/>
						) : (
							`${sectionCupom.textoDoBotaoPrimario}`
						)}
					</Button>
				</Modal>
			)}
		</Container>
	)
}
export default Planos
